export type PrometheusHaProxyBackendTotalBytesInStatsBackendApiProps = {
    created: number;
    haproxy_server_bytes_in_total: number;
};

export default class PrometheusHaProxyBackendTotalBytesInStats {
    readonly created: number;
    readonly haproxyServerBytesInTotal: number;

    constructor(
        props: PrometheusHaProxyBackendTotalBytesInStatsBackendApiProps
    ) {
        this.created = props.created;
        this.haproxyServerBytesInTotal = props.haproxy_server_bytes_in_total;
    }
}
